import Header from './components/Header'
import Meals from './components/Meals'
import { useState, useEffect } from 'react';
import AddFoodDialog from './components/AddFoodDialog'
import Login from './components/Login/Login'
// import useToken from './components/useToken';
import useUser from './components/useUser';
import Meal from './components/Meal';
import MealCard from './components/MealCard';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';


function App() {

  const { loginWithPopup, loginWithRedirect, logout, user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  // const { token, setToken } = useToken();
  // const { user, setUser } = useUser();
  const [token, setToken] = useState();
  const [meals, setMeals] = useState([]);
  const [mealsToShow, setMealsToShow] = useState([]);
  const [serverSocket, setServerSocket] = useState();
  const [clientUid, setClientUid] = useState();
  const [portions, setPortions] = useState(2);
  const [mealView, setMealView] = useState("all-meals");
  const [mealCardVisible, setMealCardVisible] = useState(false);
  const [mealForMealCard, setMealForMealCard] = useState();

  useEffect(() => {
    if (mealView === "all-meals") {
      setMealsToShow(meals);
    }
    if (mealView === "favorite-meals") {
      setMealsToShow(meals.filter((meal) => meal.isFavorite));
    }
    if (mealView === "own-meals") {
      setMealsToShow(meals.filter((meal) => meal.creatorId === user.sub));
    }
  }, [mealView, meals, user])

  useEffect(() => {
    if (token) {
      setServerSocket(new WebSocket('wss://meals.shosenfeld.com:3051'));

      fetchMeals().then(data => setMeals(data));
    }
  }, [token])

  useEffect(() => {
    if (serverSocket !== undefined) {
      serverSocket.onopen = () => serverSocket.send('NewClient');

      serverSocket.onmessage = ({ data }) => {
        const message = JSON.parse(data);
        if (message.type === "client-uid") {
          setClientUid(message.uid);
        }
        if (message.type === "NewMeal") {
          setMeals([...meals, message.meal])
        }
      }
    }
  }, [serverSocket, meals])

  //Fetch Favorites
  // const fetchFavoriteMealIds = async () => {
  //   const res = await fetch('https://meals.shosenfeld.com:3050/favorite-meal-ids/' + user.id,
  //     {
  //       headers: new Headers({
  //         'Authorization': 'Bearer ' + token
  //       }),
  //     })
  //   const data = await res.json();
  //   return data;
  // }

  //Fetch Meals
  const fetchMeals = async () => {
    const res = await fetch('https://meals.shosenfeld.com:3050/meals',
      {
        headers: new Headers({
          authorization: `Bearer ${token}`
        }),
      });

    const data = await res.json()
    data?.forEach(async function (meal) {
      const ingredientResult = await fetch('https://meals.shosenfeld.com:3050/ingredients/' + meal.id,
        {
          headers: new Headers({
            authorization: `Bearer ${token}`
          }),
        });
      meal.ingredients = await ingredientResult.json();
    })


    return data;
  }
  const uploadImage = async (image) => {

    const res = await fetch('https://meals.shosenfeld.com:3050/uploadImage', {
      method: 'POST',
      headers: new Headers({
        authorization: `Bearer ${token}`
      }),
      body: image
    })

    const data = await res.json();
    console.log(data);
  }

  //Fetch Meal
  const fetchMeal = async (id) => {
    const res = await fetch(`https://meals.shosenfeld.com:3050/meal/${id}`)
    const data = await res.json()

    return data;
  }

  //Add Meal
  const addMeal = async (meal) => {

    console.log(meal);

    const res = await fetch('https://meals.shosenfeld.com:3050/meals', {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'ClientUid': clientUid,
      },
      body: JSON.stringify(meal)
    })

    const data = await res.json();

    setMeals([...meals, data])
  }

  //Delete Meal
  const deleteMeal = async (id) => {
    if (window.confirm('Are you sure you want to delete this meal?')) {
      await fetch(`https://meals.shosenfeld.com:3050/meals/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': 'Bearer ' + token
        },
      })
      setMeals(meals.filter((meal) => meal.id !== id));
      toggleMealCard();
    } else {
      // Do nothing!
    }
  }

  const changeFavorite = async (mealId, isFavorite) => {
    if (isFavorite) {

      const favToAdd = {
        // user_id: user.id,
        user_id: user.sub,
        meal_id: mealId
      }

      const res = await fetch(`https://meals.shosenfeld.com:3050/favorite-meal-ids`, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(favToAdd)
      });
    }
    else {
      await fetch(`https://meals.shosenfeld.com:3050/favorite-meal-ids`, {
        method: 'DELETE',
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify({
          "meal_id": mealId
        })
      })
    }
  }

  const setFavorite = async (mealToModify, isFavorite) => {

    let mealsCopy = [...meals];
    let index = meals.indexOf(mealToModify);

    if (index !== -1) {
      let modifiedMeal = { ...meals[index] };
      modifiedMeal.isFavorite = isFavorite;
      mealsCopy[index] = modifiedMeal;
      setMeals(mealsCopy);
      changeFavorite(modifiedMeal.id, isFavorite);
    }
  }

  const getAccessToken = async () => {
    const token = await getAccessTokenSilently();
    setToken(token);
  }

  if (!token) {
    if (!isAuthenticated) {
      // return (
      //   <button onClick={() => { loginWithPopup() }}>Login</button>
      // );
    }
    else {
      getAccessToken();
    }
  }

  const toggleMealCard = (meal) => {
    if (!mealCardVisible) {
      setMealForMealCard(meal);
    }
    setMealCardVisible(!mealCardVisible)

  }

  return (
    <div className='container'>
      <Header username={user?.nickname} portions={portions} setPortions={setPortions} mealView={mealView} setMealView={setMealView} isLoggedIn={isAuthenticated} logout={logout} login={loginWithPopup}></Header>
      {isAuthenticated ? <>
      <AddFoodDialog addMeal={addMeal} userId={user.sub} uploadImage={uploadImage}></AddFoodDialog>
        {meals.length > 0 ? <Meals meals={mealsToShow} toggleMealCard={toggleMealCard} setFavorite={setFavorite}></Meals> : 'No meals to show'}

        {mealCardVisible ? <MealCard meal={mealForMealCard} toggleMealCard={toggleMealCard} user={user} deleteMeal={deleteMeal} portions={portions} /> : null}
      </> : <p className="center">Please log in to view our delicious meal ideas!</p>}
    </div>
  );
}

export default App;
